import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

/**
 * Convert date to "x time ago"
 */
export const convertDateToFromNow = (date) => {
  if (!date) return "";
  return dayjs.utc(date).fromNow();
};

export const convertDatesToDayjs = (data) => {
  if (Array.isArray(data)) {
    return data.map(convertDatesToDayjs);
  }

  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        convertDatesToDayjs(value),
      ]),
    );
  }
  if (typeof data === "string" && data?.includes("-") && !isNaN(Date.parse(data))) {
    return dayjs(data);
  }

  return data;
};

export const secondsToTime = (seconds) =>
  dayjs().startOf("day").add(seconds, "second").format("mm:ss");

export default dayjs;
